import { ChannelOrganization, type Websocket } from 'entities/WebSocket'
import { type OrganizationStore } from 'entities/Organization/store/organization'

export class ChannelsOrganization {
  constructor(private _websocket: Websocket) {}

  subscribeChannels = (store: OrganizationStore) => {
    if (!store.id) return

    new ChannelOrganization(
      {
        id: store.id,
      },
      this._websocket
    )
  }
}
